import { Link } from '@tanstack/react-router';
import { type FC } from 'react';
import { SERVICES } from '../content';
import { CARD_PHOTO_SIZES, Photo } from '../Photo';
import { Container, TitleBlock } from '../primitives';

export const ServiceCards: FC<{ sheet?: string }> = ({ sheet = 'DB-01 - What we do' }) => (
  <section className="py-20 sm:py-28">
    <Container>
      <TitleBlock
        sheet={sheet}
        title="Six trades, one crew, one standard"
        lede="From the slab your house stands on to the driveway you come home over: priced fixed, poured to the drawings, finished properly."
      />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((service) => (
          <Link
            key={service.slug}
            to="/services/$slug"
            params={{ slug: service.slug }}
            className="group overflow-hidden rounded-lg border border-ink-200 bg-white transition-shadow duration-200 hover:shadow-xl focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500"
          >
            <div className="relative aspect-[3/2] overflow-hidden">
              <Photo
                photo={service.image}
                alt={service.imageAlt}
                sizes={CARD_PHOTO_SIZES}
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
              />
            </div>
            <div className="p-5">
              <h3 className="font-display text-lg font-bold text-ink-900">{service.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-600">{service.summary}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 font-mono text-xs tracking-wide text-brand-600 uppercase">
                View service
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path d="M3 8h10m0 0L9 4m4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </Container>
  </section>
);
